/*
 * File: PortalUserModel.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/17/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Store/model for a Patient Portal User.
 */

import { computed, decorate, observable } from "mobx";

class PortalUserModel {
  userId;
  firstName = "";
  lastName = "";
  username = "";

  constructor(obj) {
    Object.assign(this, obj);
  }

  get fullName() {
    return this.firstName + " " + this.lastName;
  }
}

decorate(PortalUserModel, {
  firstName: observable,
  lastName: observable,
  username: observable,
  fullName: computed
});

export default PortalUserModel;
